module.exports = __webpack_public_path__ + "img/10-min.3840dd89.jpg";